$(function() {
    "use strict";

    $(document).on('change', '.yellow-form__switcher', function (e) {
        e.preventDefault();

        var $yellowForm = $(this).closest('.yellow-form__wrapper').find('.yellow-form');

        if ($yellowForm.length) {
            if ($(this).is(':checked')) {
                $yellowForm.removeClass('yellow-form_hidden');
            } else {
                $yellowForm.addClass('yellow-form_hidden');
            }
        }
    });
});
